import React from "react";
// import tw from "twin.macro";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Header from "components/headers/light.js";
import Footer from "components/footers/SimpleFiveColumn.js";
import Blog from "components/blogs/PopularAndRecentBlogPosts.js";
import { BlogData } from "../assets/blogData";

// const HighlightedText = tw.span`text-primary-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <Blog
        heading={BlogData.heading}
        recentHeading={BlogData.recentHeading}
        popularPosts={BlogData.popularPosts}
        recentPosts={BlogData.recentPosts}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
